import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import * as actions from 'actions';

import SearchBar from 'containers/SearchBar';
import Link from 'components/Link';
import MainNavigationDropdownHeader from '../MainNavigation/MainNavigationDropdownHeader';

import './style.scss';

export class More extends Component {

  constructor() {
    super();
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
  }

  handleLogoutClick(event) {
    event.preventDefault();
    this.props.onLogout();
  }

  render() {
    return (
      <section className="content-wrapper has-background-medium">
        <div className="wrapper-small is-collapsed">
          <div className="MoreSearchBar">
            <SearchBar />
          </div>

          <div className="user-menu-wrapper">
            <MainNavigationDropdownHeader />

            <ul className="user-menu has-border-on-last">
              <li>
                <Link to="/goals">{__('members.navigation.goals')}</Link>
              </li>
              <li>
                <Link to="/journal">{__('members.navigation.journal')}</Link>
              </li>
              <li>
                <Link to="/links">{__('members.navigation.links')}</Link>
              </li>
              <li>
                <Link to="/interests">{__('members.navigation.interests')}</Link>
              </li>
              <li>
                <a className="Link" target="_blank" href={`${process.env.KOOTH_UNAUTH_URL}/team.html`}>{__('members.navigation.team')}</a>
              </li>
              <li>
                <Link to="/feedback">{__('members.navigation.feedback')}</Link>
              </li>
              <li>
                <a className="Link is-half-opaque" onClick={this.handleLogoutClick}>{__('members.navigation.logout')}</a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

More.propTypes = {
  onLogout: PropTypes.func
};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => {
      dispatch(actions.authLogout());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(More);



/** WEBPACK FOOTER **
 ** ./src/members/Main/More/index.js
 **/